import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    FilterType,
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    ActivityRecordType,
} from 'app/enums/label.enums'
import {
    ActivityRecordTable,
} from './activityRecords.types'

const config: SkyNetTableConfig<keyof ActivityRecordTable> = {
    name: 'ActivityRecords',
    tabs: [{
        name: 'All',
        url: CommonRoutes.All,
        fields: [
            {
                name: 'companiesCompanyName',
                componentName: 'List',
                filterField: 'companiesCompanyName',
                filterType: FilterType.Array,
                reduced: true,
                labelKey: 'COMPANY',
            },
            {
                name: 'participants',
                componentName: 'List',
                reduced: true,
                labelKey: 'PARTICIPANTS',
            },
            {
                name: 'subject',
                reduced: true,
                labelKey: 'SUBJECT',
            },
            {
                name: 'type',
                componentName: 'EnumValue',
                allowedValuesEnum: ActivityRecordType,
                labelKey: 'TYPE',
            },
            {
                name: 'organizer',
                filterField: 'organizer',
                filterType: FilterType.Array,
                labelKey: 'ORGANIZER',
            },
            {
                name: 'isFollowUpNeeded',
                filterField: 'isFollowUpNeeded',
                filterType: FilterType.Array,
                componentName: 'ChipCheckMark',
                labelKey: 'FOLLOW_UP_NEEDED',
            },
            {
                name: 'happenedOn',
                componentName: 'DateTimeCell',
                labelKey: 'HAPPENED_ON',
            },
            {
                name: 'durationInMinutes',
                componentName: 'AmountOfTime',
                labelKey: 'DURATION',
            },
            {
                name: 'changedOn',
                componentName: 'DateTimeCell',
                labelKey: 'LAST_UPDATED',
            },
        ],
    }],
}

export default config
